/**
 * @generated SignedSource<<094f2dd437bb86c61ede90c29743a32d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ContentUsageEntity = "collection" | "content" | "content_usage_confirmation" | "curriculum" | "dashboard_block_content" | "member_onboarding" | "organization" | "product_app" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ContentModuleAdminDropdownFragment$data = {
  readonly entity: ContentUsageEntity;
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"ContentUsageAssociateEventsButtonFragment" | "CreateContentModuleItemButtonFragment" | "DeleteContentUsageButtonFragment" | "UpdateContentModuleButtonFragment">;
  readonly " $fragmentType": "ContentModuleAdminDropdownFragment";
};
export type ContentModuleAdminDropdownFragment$key = {
  readonly " $data"?: ContentModuleAdminDropdownFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ContentModuleAdminDropdownFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContentModuleAdminDropdownFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entity",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "CreateContentModuleItemButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "UpdateContentModuleButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DeleteContentUsageButtonFragment"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContentUsageAssociateEventsButtonFragment"
    }
  ],
  "type": "ContentUsage",
  "abstractKey": null
};

(node as any).hash = "68a778daaf5572a04d8839bd119b1c92";

export default node;
